.sn-how-to-decoration {
  display: block;
  position: relative;
}

.how-to-sign-slider {
  z-index: 1;

  @include above(960px) {
    display: none;
  }

  &.slick-initialized {
    display: block;
  }

  .slick-list {
    overflow: hidden;
    margin-left: -16px;
    margin-right: -16px;
    margin-top: -32px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 32px;

    &.is-open {
      overflow: initial;
    }

    @include above(640px) {
      margin-top: -62px;
      padding-top: 62px;
    }

    @include above(960px) {
      margin: 0;
      padding: 0;
      overflow: inherit;
    }
  }

  .slick-slide {
    z-index: 1;

    &.slick-current {
      .sign-explanation__link {
        display: inline-block;

        @include above(960px) {
          display: none;
        }
      }
    }
  }

  .numbered-list__item {
    padding: 0;

    .brackets-wrapper {
      margin-right: 8px;
      position: relative;
      padding: 0;

      &::before,
      &::after {
        display: none;
      }
    }
  }
}

.page-section--how-to-sign {
  position: relative;
  padding-bottom: 64px;

  @include above(640px) {
    padding-bottom: 72px;
  }

  @include above(960px) {
    padding-bottom: 64px;
    padding-top: 15px;
  }

  @include above(1280px) {
    padding-bottom: 72px;
  }

  .section-subtitle {
    font-family: Graphik, Arial, sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 16px;

    @include above(375px) {
      margin-bottom: 13px;
    }

    @include above(640px) {
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 15px;
    }

    @include above(1480px) {
      font-size: 52px;
      line-height: 64px;
      margin-bottom: 20px;
    }
  }

  .section-message {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 32px;
    text-align: center;

    @include above(375px) {
      font-size: 16px;
      line-height: 24px;
    }

    @include above(640px) {
      margin-bottom: 40px;
      font-size: 20px;
      line-height: 32px;
      max-width: 512px;
      margin-left: auto;
      margin-right: auto;
    }

    @include above(960px) {
      margin-left: 0;
      margin-right: 0;
      max-width: inherit;
    }

    @include above(1280px) {
      margin-bottom: 72px;
    }
  }

  .slick-dots {
    display: none !important;
  }
}

.navigation-options {
  display: none;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 8px 40px 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  overflow: hidden;

  @include above(960px) {
    margin-bottom: 73px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @include above(1280px) {
    margin-bottom: 100px;
  }

  &::after {
    display: block;
    position: absolute;
    content: '';
    width: 80px;
    top: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(to right, rgb(255 255 255 / 0%), #fff 100%);

    @include above(1280px) {
      display: none;
    }
  }

  .slick-track {
    display: flex;
    justify-content: space-between;
  }

  .slick-slide {
    float: none;

    // width auto !important
  }
}

.navigation-options__item {
  position: relative;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 18px;
  white-space: nowrap;
  text-align: center;
  cursor: pointer;
  outline: none;

  @include above(1280px) {
    font-size: 16px;
    line-height: 28px;
    padding: 18px 30px;
  }

  &:hover {
    .navigation-options__link {
      color: #0777cf;
    }
  }

  &.is-active {
    &::before {
      position: absolute;
      content: '';
      height: 4px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #0777cf;
      animation: expansion 0.25s;
    }
  }
}

.how-to-sign-accordion-title {
  display: block;
  position: relative;
  font-size: 12px;
  line-height: 20px;
  font-weight: bold;
  border-radius: 4px;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  padding: 14px 16px;
  margin-bottom: 20px;

  @include above(375px) {
    line-height: 16px;
    box-shadow: 0 6px 20px 0 rgb(0 0 0 / 10%);
  }

  @include above(640px) {
    font-size: 14px;
    box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
    margin-bottom: 24px;
    padding: 16px 20px;
  }

  &.is-active {
    @include above(640px) {
      box-shadow: 0 8px 20px 0 rgb(0 0 0 / 15%);
    }

    &::after {
      background-image: url('../images/home/how-to-sign/arrow-icon-up.svg');
    }
  }

  &::before {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    left: 0;
    width: 4px;
    background-color: #0777cf;
  }

  &::after {
    position: absolute;
    content: '';
    width: 12px;
    height: 7px;
    background-image: url('../images/home/how-to-sign/arrow-icon.svg');
    background-repeat: no-repeat;
    background-size: contain;
    right: 16px;
    top: 19px;

    @include above(640px) {
      right: 20px;
    }
  }

  @include above(960px) {
    display: none;
  }
}

.page-section__row--how-to-sign {
  display: block !important;
  margin-left: auto;
  margin-right: auto;
  max-width: 288px;
  padding-bottom: 54px;

  @include above(375px) {
    max-width: 343px;
  }

  @include above(640px) {
    max-width: 512px;
  }

  @include above(960px) {
    max-width: inherit;
    margin: 0;
    display: flex !important;
    padding-bottom: 0;
  }

  &.is-open {
    display: block;

    @include above(960px) {
      display: flex;
    }
  }

  @keyframes fade-in-right {
    from {
      opacity: 0;
      transform: translate3d(20%, 0, 0);
    }

    to {
      opacity: 1;
      transform: none;
    }
  }
}

.page-section__column--details {
  padding-top: 60px;

  @include above(640px) {
    padding-top: 67px;
  }

  @include above(960px) {
    margin-left: 60px;
    padding-top: 0;
  }

  @include above(1280px) {
    width: 608px;
    flex-shrink: 0;
    margin-left: 80px;

    .page-section__column--media {
      margin-top: 0;
      min-height: 236px;
      margin-bottom: 32px;

      @include above(640px) {
        width: 512px;
        min-height: 442px;
      }

      @include above(960px) {
        width: 420px;
        margin-bottom: 0;
        min-height: inherit;
      }

      @include above(1280px) {
        width: 560px;
      }
    }
  }
}

.page-section__column--media {
  position: relative;
  width: 277px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;
  min-height: 236px;

  @include above(375px) {
    width: 331px;
  }

  @include above(640px) {
    width: 512px;
    min-height: 442px;
  }

  @include above(960px) {
    flex-shrink: 0;
    width: 420px;
    min-height: inherit;
    margin: 0;
  }

  @include above(1280px) {
    width: 560px;
  }
}

.sign-illustration {
  position: relative;
  height: 100%;
  min-height: 236px;

  @include above(640px) {
    min-height: 442px;
  }

  @include above(960px) {
    min-height: 300px;
  }

  @include above(1280px) {
    min-height: 442px;
  }

  .sign-illustration__image-primary,
  .sign-illustration__image-secondary {
    position: absolute;
  }

  &.sign-illustration--screen01 {
    .sign-illustration__square {
      background-color: #94ead9;
    }

    .sign-illustration__image-primary {
      top: 16px;
      left: 0;
      animation-delay: 0.3s;

      @include above(375px) {
        left: 21px;
      }

      @include above(640px) {
        left: -7px;
        top: 31px;
      }

      @include above(960px) {
        top: 31px;
        left: 24px;
      }

      @include above(1280px) {
        left: auto;
      }

      img {
        width: 100%;
        height: auto;
        box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(375px) {
          @include size(280px, 186px);
        }

        @include above(640px) {
          @include size(525px, 350px);

          border-radius: 8px;
          box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        }

        @include above(960px) {
          @include size(378px, 252px);
        }

        @include above(1280px) {
          @include size(525px, 350px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 119px;
      right: -6px;
      animation-delay: 0.7s;

      @include above(375px) {
        right: 20px;
      }

      @include above(640px) {
        top: 223px;
        right: -27px;
      }

      @include above(960px) {
        right: 0;
        top: 180px;
      }

      @include above(1280px) {
        top: 223px;
      }

      img {
        @include size(170px, 116px);

        box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(640px) {
          @include size(320px, 220px);

          border-radius: 8px;
          box-shadow: 0 8px 40px rgb(0 0 0 / 10%);
        }

        @include above(960px) {
          @include size(240px, 165px);
        }

        @include above(1280px) {
          @include size(320px, 220px);
        }
      }
    }
  }

  &.sign-illustration--screen02 {
    .sign-illustration__square {
      background-color: #ffe289;
    }

    .sign-illustration__image-primary {
      top: 16px;
      left: 0;
      animation-delay: 0.3s;

      @include above(375px) {
        left: 21px;
      }

      @include above(640px) {
        left: -7px;
        top: 31px;
      }

      @include above(960px) {
        top: 31px;
        left: 24px;
      }

      @include above(1280px) {
        left: auto;
      }

      img {
        width: 100%;
        height: auto;
        box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(375px) {
          @include size(280px, 186px);
        }

        @include above(640px) {
          @include size(525px, 350px);

          border-radius: 8px;
          box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        }

        @include above(960px) {
          @include size(378px, 252px);
        }

        @include above(1280px) {
          @include size(525px, 350px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 110px;
      right: -6px;
      animation-delay: 0.7s;

      @include above(375px) {
        right: 10px;
      }

      @include above(640px) {
        top: 232px;
        right: -27px;
      }

      @include above(960px) {
        right: 0;
        top: 180px;
      }

      @include above(1280px) {
        top: 232px;
      }

      img {
        @include size(150px, 125px);

        filter: drop-shadow(0 4px 21px rgb(0 0 0 / 10%));
        border-radius: 4px;

        @include above(640px) {
          @include size(255px, 212px);

          border-radius: 8px;
          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }

        @include above(960px) {
          @include size(200px, 166px);
        }

        @include above(1280px) {
          @include size(255px, 212px);
        }
      }
    }
  }

  &.sign-illustration--screen03 {
    .sign-illustration__square {
      background-color: #ffeede;
    }

    .sign-illustration__image-primary {
      top: 16px;
      left: 0;
      animation-delay: 0.3s;

      @include above(375px) {
        left: 21px;
      }

      @include above(640px) {
        left: -7px;
      }

      @include above(960px) {
        top: 31px;
        left: 24px;
      }

      @include above(1280px) {
        left: auto;
      }

      img {
        width: 100%;
        height: auto;
        box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(375px) {
          @include size(280px, 186px);
        }

        @include above(640px) {
          @include size(525px, 350px);

          border-radius: 8px;
          box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        }

        @include above(960px) {
          @include size(378px, 252px);
        }

        @include above(1280px) {
          @include size(525px, 350px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 110px;
      right: -6px;
      animation-delay: 0.7s;

      @include above(375px) {
        right: 10px;
      }

      @include above(640px) {
        top: 294px;
        right: -27px;
      }

      @include above(960px) {
        right: 0;
        top: 180px;
      }

      @include above(1280px) {
        top: 294px;
      }

      img {
        @include size(122px, 123px);

        box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(640px) {
          @include size(150px, 150px);

          border-radius: 8px;
          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }
      }
    }

    .sign-illustration__button {
      position: absolute;

      @include size(88px, 30px);

      top: 126px;
      left: -10px;
      animation-delay: 0.9s;

      @include above(375px) {
        left: 2px;
      }

      @include above(640px) {
        top: 241px;

        @include size(156px, 54px);

        border-radius: 8px;
        filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        left: -32px;
      }

      @include above(960px) {
        top: 182px;
        left: 0;
      }

      @include above(1280px) {
        top: 241px;
        left: -52px;
      }

      img {
        max-width: 100%;
      }
    }
  }

  &.sign-illustration--screen04 {
    .sign-illustration__square {
      background-color: #f9d5df;
    }

    .sign-illustration__image-primary {
      z-index: 1;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      top: -6px;

      @include size(109px, 229px);

      animation-delay: 0.3s;

      @include above(640px) {
        @include size(210px, 442px);
      }

      @include above(960px) {
        left: 65px;
      }

      @include above(1280px) {
        left: 165px;
        margin-left: 0;
        margin-right: 0;
      }

      img {
        max-width: 100%;

        @include size(109px, 229px);

        box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
        border-radius: 8px;

        @include above(640px) {
          @include size(210px, 442px);

          box-shadow: 0 8px 40px rgb(0 0 0 / 10%);
        }

        @include above(960px) {
          @include size(160px, 337px);
        }

        @include above(1280px) {
          @include size(210px, 442px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 43px;
      left: 40px;
      animation-delay: 0.7s;

      @include above(640px) {
        top: 85px;
        left: 51px;
      }

      @include above(960px) {
        top: 53px;
      }

      @include above(1280px) {
        top: 85px;
        left: 33px;
      }

      img {
        @include size(100px, 134px);

        box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(640px) {
          @include size(164px, 220px);

          box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        }
      }
    }

    .sign-illustration__image-tertiary {
      position: absolute;
      top: 43px;
      right: 40px;
      animation-delay: 0.7s;

      @include above(640px) {
        top: 85px;
        right: 51px;
      }

      @include above(960px) {
        top: 53px;
      }

      @include above(1280px) {
        top: 85px;
        right: 51px;
      }

      img {
        @include size(100px, 134px);

        box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
        border-radius: 4px;

        @include above(640px) {
          @include size(164px, 220px);

          box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        }
      }
    }
  }

  &.sign-illustration--screen05 {
    .sign-illustration__square {
      background-color: #d7e7fd;
    }

    .sign-illustration__image-primary {
      top: -29px;
      left: 16px;
      animation-delay: 0.3s;

      @include above(375px) {
        left: 42px;
      }

      @include above(640px) {
        top: -46px;
        left: 24px;
      }

      @include above(1280px) {
        left: 45px;
      }

      img {
        @include size(140px, 228px);

        @include above(640px) {
          @include size(262px, 427px);

          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }

        @include above(960px) {
          @include size(202px, 329px);
        }

        @include above(1280px) {
          @include size(262px, 427px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 30px;
      right: 16px;
      animation-delay: 0.7s;

      @include above(375px) {
        right: 42px;
      }

      @include above(640px) {
        top: 49px;
        right: 24px;
      }

      @include above(1280px) {
        right: 57px;
      }

      img {
        @include size(140px, 228px);

        @include above(640px) {
          @include size(262px, 427px);

          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }

        @include above(960px) {
          @include size(202px, 329px);
        }

        @include above(1280px) {
          @include size(262px, 427px);
        }
      }
    }
  }

  &.sign-illustration--screen06 {
    .sign-illustration__square {
      background-color: #eee8fe;
    }

    .sign-illustration__image-primary {
      top: -30px;
      left: 16px;
      animation-delay: 0.3s;

      @include above(375px) {
        left: 42px;
      }

      @include above(640px) {
        top: -54px;
        left: 24px;
      }

      @include above(1280px) {
        left: 45px;
        top: -46px;
      }

      img {
        @include size(140px, 247px);

        @include above(640px) {
          @include size(261px, 460px);

          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }

        @include above(960px) {
          @include size(202px, 329px);
        }

        @include above(1280px) {
          @include size(261px, 460px);
        }
      }
    }

    .sign-illustration__image-secondary {
      top: 20px;
      right: 16px;
      animation-delay: 0.7s;

      @include above(375px) {
        top: 25px;
        right: 42px;
      }

      @include above(640px) {
        top: 24px;
        right: 24px;
      }

      @include above(1280px) {
        right: 57px;
      }

      img {
        @include size(140px, 247px);

        @include above(640px) {
          @include size(261px, 460px);

          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
        }

        @include above(960px) {
          @include size(202px, 329px);
        }

        @include above(1280px) {
          @include size(261px, 460px);
        }
      }
    }
  }
}

.sign-illustration__square {
  @include size(228px, 220px);

  border-radius: 4px;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;

  @include above(640px) {
    @include size(426px, 414px);

    border-radius: 8px;
  }

  @include above(960px) {
    @include size(326px, 317px);
  }

  @include above(1280px) {
    @include size(426px, 414px);

    left: -22px;
  }
}

.sign-explanation__title {
  font-family: Graphik, Arial, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #2c2c2c;
  margin-bottom: 20px;

  @include above(640px) {
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 16px;
  }
}

.sign-explanation__description {
  font-size: 14px;
  line-height: 24px;
  max-height: 96px;
  overflow: hidden;

  @include above(960px) {
    max-height: inherit;
    overflow: inherit;
  }

  &.is-open {
    max-height: inherit;
    overflow: inherit;
  }

  p,
  ul {
    margin-bottom: 8px;

    @include above(640px) {
      margin-bottom: 12px;
    }

    @include above(1280px) {
      margin-bottom: 16px;
    }
  }

  li {
    margin-bottom: 0;

    @include above(640px) {
      margin-bottom: 12px;
    }
  }

  .link {
    margin-right: 18px;

    &::after {
      content: '...';
      position: absolute;
      top: -2px;
      right: -18px;
      bottom: 0;
      height: 4px;
      margin: auto;
      line-height: 0;
      font-weight: 800;
    }
  }

  .sign-explanation-hidden-text {
    display: none;

    .link {
      margin-right: 21px;

      &::after {
        display: block;
        position: absolute;
        top: 0;
        right: -16px;
        transform: rotate(-90deg);
        width: 12px;
        height: 20px;
        background: url('../images/global/link-arrow.svg') no-repeat center right;
        content: '';
        background-size: contain;

        @include above(640px) {
          width: 15px;
          top: 3px;
          right: -20px;
        }

        @include above(960px) {
          top: 9px;
          width: 24px;
          right: -25px;
          background-size: auto;
        }
      }
    }
  }
}

.sign-explanation__list-title {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 12px;
}

@keyframes expansion {
  from {
    width: 1%;
  }

  to {
    width: 100%;
  }
}

.workflows-details__link {
  &:focus {
    text-decoration: none;
    outline: none;

    &::before {
      width: 100%;
      left: 0;
    }
  }
}

.how-to-sign-nav {
  display: flex;
  justify-content: space-between;
  text-align: left;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  z-index: 9;
  align-items: center;

  @include above(640px) {
    width: 512px;
    margin-top: 24px;
  }

  @include above(960px) {
    width: 448px;
    position: absolute;
    left: 0;
    top: 394px;
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
  }

  @include above(1280px) {
    width: 560px;
    top: 489px;
  }

  .slider-nav__arrow {
    display: flex;
  }

  .btn-prev-arrow,
  .btn-next-arrow {
    position: relative;

    @include size(36px);

    border: none;
    outline: none;
    cursor: pointer;
    background: none;

    @include above(640px) {
      @include size(40px);
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;

      @include size(36px);

      border: 1.5px solid #9da9b3;
      border-radius: 50%;
      box-sizing: border-box;

      @include above(640px) {
        @include size(40px);
      }
    }

    &::after {
      content: '';
      position: absolute;
      background: url('../images/e-signature/arrow-new.svg') no-repeat;
      background-size: contain;

      @include size(12px, 11px);

      inset: 0;
      margin: auto;

      @include above(640px) {
        @include size(16px, 14px);
      }
    }

    &:hover {
      &::before {
        border: 1.5px solid #81919d;
      }
    }

    &:focus {
      box-shadow: 0 0 0 1.5px #d5dade;
      border-radius: 100%;
    }
  }

  .btn-prev-arrow {
    margin-right: 15px;

    @include above(640px) {
      margin-right: 18px;
    }

    &::after {
      transform: rotate(180deg);
    }
  }

  .slider-nav__counter {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 24px;
    justify-content: flex-end;

    @include above(960px) {
      justify-content: flex-start;
      font-size: 16px;
      line-height: 28px;
    }
  }
}

.how-to-sign-nav__counter {
  @include above(1280px) {
    font-size: 16px;
    line-height: 16px;
  }
}

.is-disable {
  pointer-events: none;
  object-fit: contain;
  opacity: 0.5;

  &::before {
    transform: none;
  }
}

.how-to-sign-wrapper {
  position: relative;
}

.sign-explanation__link {
  font-size: 14px;
  line-height: 28px;
  padding-right: 21px;
  display: inline-block;
  margin-top: 12px;

  &.less {
    margin-top: 8px;
  }

  @include above(640px) {
    font-size: 16px;
  }

  @include above(960px) {
    padding-right: 21px;
    display: none;
  }

  &::after {
    position: absolute;
    content: '';

    @include size(16px, 4px);

    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAwQzAuODk1NDMxIDAgMCAwLjg5NTQzMSAwIDJDMCAzLjEwNDU3IDAuODk1NDMxIDQgMiA0QzMuMTA0NTcgNCA0IDMuMTA0NTcgNCAyQzQgMC44OTU0MzEgMy4xMDQ1NyAwIDIgMFpNNiAyQzYgMC44OTU0MzEgNi44OTU0MyAwIDggMEM5LjEwNDU3IDAgMTAgMC44OTU0MzEgMTAgMkMxMCAzLjEwNDU3IDkuMTA0NTcgNCA4IDRDNi44OTU0MyA0IDYgMy4xMDQ1NyA2IDJaTTEyIDJDMTIgMC44OTU0MzEgMTIuODk1NCAwIDE0IDBDMTUuMTA0NiAwIDE2IDAuODk1NDMxIDE2IDJDMTYgMy4xMDQ1NyAxNS4xMDQ2IDQgMTQgNEMxMi44OTU0IDQgMTIgMy4xMDQ1NyAxMiAyWiIgZmlsbD0iIzA3NzdDRiIvPgo8L3N2Zz4K');
    bottom: 8px;
    right: 0;
  }
}

.zoomIn,
.zoom-in {
  animation-name: zoom-in;
}

.fadeInUp,
.fade-in-up {
  animation-name: fade-in-up;
}

.fadeInDown,
.fade-in-down {
  animation-name: fade-in-down;
}

.fadeInLeftLong,
.fade-in-left-long {
  animation-name: fade-in-left-long;
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translate3d(0, 30px, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translate3d(0, -30px, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fade-in-left-long {
  from {
    opacity: 0;
    transform: translate3d(-82%, 0, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInRightLong,
.fade-in-right-long {
  animation-name: fade-in-right-long;
}

@keyframes fade-in-right-long {
  from {
    opacity: 0;
    transform: translate3d(82%, 0, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes zoom-in {
  0% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50% {
    transform: scale3d(1, 1, 1);
  }
}
